var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gantt-chart-container" }, [
    _vm.$truckLoading || _vm.isManualAssignLoading || _vm.isAutoAssignLoading
      ? _c("div", { staticClass: "loader-round" })
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !(
              _vm.$truckLoading ||
              _vm.isManualAssignLoading ||
              _vm.isAutoAssignLoading
            ),
            expression:
              "!($truckLoading || isManualAssignLoading || isAutoAssignLoading)",
          },
        ],
        staticClass: "scroll-bar-wrap",
        style: _vm.gcContainerStyle,
      },
      [
        _vm.filteredTrucks.length >= 1
          ? _c(
              "div",
              {
                ref: "ganttChart",
                staticClass: "gantt-chart scroll-box",
                attrs: { id: "ganttChart" },
              },
              [
                _c("transfer-order-modal", {
                  attrs: {
                    isAutoAssign: _vm.isAutoAssign,
                    isVisible: _vm.openMapModal,
                  },
                  on: { modalClose: _vm.handleTransferModalClose },
                }),
                _c(
                  "el-row",
                  {
                    staticClass: "gantt-chart-header",
                    style: _vm.gcHeaderStyle,
                    attrs: { type: "flex" },
                  },
                  [
                    _c("el-col", {
                      staticClass: "left",
                      style: {
                        width: _vm.$isMobile
                          ? _vm.smallLeftWidth + "px"
                          : _vm.leftWidth + "px",
                      },
                    }),
                    _c(
                      "el-col",
                      { staticClass: "right" },
                      _vm._l(_vm.timeList, function (date, dateIndex) {
                        return _c(
                          "div",
                          {
                            key: dateIndex,
                            staticClass: "time-list-container",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "time-list-date",
                                style: {
                                  left:
                                    _vm.ganttChartCellWidth *
                                      date.timeList[0].counter -
                                    20 +
                                    "px",
                                },
                              },
                              [_vm._v(" " + _vm._s(date.date) + " ")]
                            ),
                            _vm._l(date.timeList, function (time, timeIndex) {
                              return _c(
                                "div",
                                {
                                  key: timeIndex,
                                  staticClass: "time-list",
                                  style: {
                                    left:
                                      _vm.ganttChartCellWidth * time.counter +
                                      "px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        position: "absolute",
                                        left: "-20px",
                                      },
                                    },
                                    [_vm._v(_vm._s(time.time))]
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    staticClass: "vertical-lines-header",
                    style: _vm.gcHeaderStyle,
                    attrs: { type: "flex" },
                  },
                  [
                    _c("el-col", { staticClass: "left" }),
                    _c(
                      "el-col",
                      {
                        staticClass: "right",
                        style: {
                          "margin-left": _vm.$isMobile
                            ? _vm.smallLeftWidth + "px"
                            : _vm.leftWidth + "px",
                        },
                      },
                      _vm._l(_vm.timeList, function (date, dateIndex) {
                        return _c(
                          "div",
                          {
                            key: "t" + dateIndex,
                            staticClass: "vertical-lines-container",
                          },
                          _vm._l(date.timeList, function (time, timeIndex) {
                            return dateIndex !== 0 || timeIndex !== 0
                              ? _c("div", {
                                  key: "t" + timeIndex,
                                  staticClass: "vertical-lines",
                                  style: {
                                    left:
                                      _vm.ganttChartCellWidth * time.counter +
                                      "px",
                                    height:
                                      _vm.filteredTrucks.length * 31 + "px",
                                  },
                                })
                              : _vm._e()
                          }),
                          0
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._l(_vm.filteredTrucks, function (truck, truckIndex) {
                  return _c(
                    "el-row",
                    {
                      key: truckIndex,
                      staticClass: "truck no-gutters",
                      class: _vm.getGCRowClass(truck, truckIndex),
                      style: _vm.getGCRowStyle(truck, truckIndex),
                      attrs: { type: "flex" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.setTruck(truck.id)
                        },
                      },
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "truck-header",
                          style: {
                            width: _vm.$isMobile
                              ? _vm.smallLeftWidth + "px"
                              : _vm.leftWidth + "px",
                          },
                        },
                        [
                          _vm.isShowCheckmark(truck)
                            ? _c(
                                "div",
                                { staticClass: "d-none d-md-block" },
                                [
                                  _vm.checkDisable(truck.id)
                                    ? _c("font-awesome-icon", {
                                        staticClass: "truck-disable",
                                        attrs: { icon: "ban" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.enableTruck(truck.id)
                                          },
                                        },
                                      })
                                    : _c("font-awesome-icon", {
                                        staticClass: "truck-enable",
                                        attrs: { icon: "check-circle" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.disableTruck(truck.id)
                                          },
                                        },
                                      }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.hasData(truck.id)
                            ? _c("font-awesome-icon", {
                                staticClass: "truck-map d-none d-md-block",
                                class: {
                                  "cursor-pointer": !_vm.isTruckIdExistInGlobal(
                                    truck.id
                                  ),
                                },
                                attrs: { icon: "globe-asia" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.openMap(
                                      truck.id,
                                      truck.plateNumber
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.doesTruckHasUpdate(truck.id)
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "d-none d-md-block",
                                  attrs: { placement: "left" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("planning.hasUpdatedFields")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("font-awesome-icon", {
                                    staticClass: "truck-has-update",
                                    attrs: { icon: "bullhorn" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isTruckOrderSentToWarehouse(truck.id)
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "d-none d-md-block",
                                  attrs: { placement: "left" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("planning.sentToWarehouse")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("font-awesome-icon", {
                                    staticClass: "truck-sent",
                                    attrs: { icon: "paper-plane" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isTruckOrderConfirmByWarehouse(truck.id)
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "d-none d-md-block",
                                  attrs: { placement: "left" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.confirmedByWarehouse"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("font-awesome-icon", {
                                    staticClass: "truck-confirmed",
                                    attrs: { icon: "check-double" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isAutoAssign &&
                          (!_vm.isValidTruck(truck) ||
                            _vm.checkDisable(truck.id))
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "d-none d-md-block",
                                  attrs: { placement: "left" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.truckLocked1"
                                            )
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " · " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.truckLocked2"
                                            )
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " · " +
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.truckLocked3"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("font-awesome-icon", {
                                    staticClass: "lock-check",
                                    attrs: { icon: "lock" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-tooltip",
                            { attrs: { placement: "left" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(" " + _vm._s(truckIndex + 1)),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("general.usedBy")) +
                                      ": " +
                                      _vm._s(
                                        _vm.getGlobalTruckInfo(
                                          truck.id,
                                          "userName"
                                        )
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.plateNumber")
                                      ) +
                                      ": " +
                                      _vm._s(truck.plateNumber || "-")
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.vehicleType")
                                      ) +
                                      ": " +
                                      _vm._s(truck.vehicleType || "-")
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.truckType")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        truck.truckType
                                          ? "" + truck.truckType
                                          : "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.columns.truckCommodityType"
                                        )
                                      ) +
                                      ": " +
                                      _vm._s(
                                        truck.truckCommodityType
                                          ? "" + truck.truckCommodityType
                                          : "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.brandName")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        truck.brandName
                                          ? "" + truck.brandName
                                          : "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.columns.weightCapacity"
                                        )
                                      ) +
                                      ": " +
                                      _vm._s(
                                        truck.weight
                                          ? "" +
                                              _vm.helper.printThousandDecimal(
                                                truck.weight
                                              )
                                          : 0
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.columns.volumeCapacity"
                                        )
                                      ) +
                                      ": " +
                                      _vm._s(
                                        truck.volume
                                          ? "" +
                                              _vm.helper.printThousandDecimal(
                                                parseFloat(truck.volume)
                                              )
                                          : 0
                                      )
                                  ),
                                  _c("br"),
                                ]
                              ),
                              _c("font-awesome-icon", {
                                style: {
                                  "margin-left": _vm.isAutoAssign ? "20px" : 0,
                                },
                                attrs: { icon: "info-circle" },
                              }),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "title ml-1" }, [
                            _vm._v(_vm._s(truck.plateNumber)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "truck-timetable",
                          style: {
                            width: _vm.$isMobile
                              ? "calc(100% - " + _vm.smallLeftWidth + "px)"
                              : "calc(100% - " + _vm.leftWidth + "px)",
                          },
                        },
                        [
                          _vm.isToday
                            ? _c("div", {
                                staticClass: "current-time",
                                style: { left: _vm.currentTimeLeft + "px" },
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "content" },
                            _vm._l(
                              _vm.getRoutes(truck.id),
                              function (route, routeIndex) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      "r-" +
                                      route.masterpointId +
                                      "-" +
                                      routeIndex,
                                    staticClass: "position-absolute",
                                    class: _vm.getStatusColor(route),
                                    style: _vm.getContainerStyles(route),
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "travelling-time",
                                      style: _vm.getRouteStyles(
                                        route,
                                        "travellingTime"
                                      ),
                                    }),
                                    _c("div", {
                                      staticClass: "handling-time",
                                      style: _vm.getRouteStyles(
                                        route,
                                        "processingTime"
                                      ),
                                    }),
                                    _c("span", { staticClass: "route-index" }, [
                                      _vm._v(_vm._s(routeIndex + 1)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "v-cover-bar" }),
        _c("div", { staticClass: "h-cover-bar" }),
        _vm.filteredTrucks.length === 0
          ? _c("div", [
              _c("p", { staticClass: "no-vehicle" }, [
                _vm._v(_vm._s(_vm.$t("truck.noVehicle"))),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }